import { IConfigStorage } from "../../Common/IConfigStorage";
import { ExecutionData } from "../../Common/Data/ExecutionData/ExecutionData";

export class FlowThreadData implements IConfigStorage {
    threadId: string;
    fromThread?: string;
    executionData: ExecutionData;

    constructor(threadId: string, executionData: ExecutionData) {
        this.threadId = threadId;
        this.executionData = executionData;
    }

    getStorageData(): object {
        let d = {};

        Reflect.set(d, "threadId", this.threadId);
        Reflect.set(d, "fromThread", this.fromThread);
        Reflect.set(d, "data", this.executionData.getStorageData());

        return d;
    }

    setStorageData(d: object): void {
        this.fromThread = Reflect.get(d, "fromThread");
        this.threadId = Reflect.get(d, "threadId");
        let dd = Reflect.get(d, "data");

        this.executionData = new ExecutionData();
        this.executionData.setStorageData(dd);
    }
}
